import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import parse from 'html-react-parser'

const Description = ({ description: _description, setDescription }) => {
  const description = parse(_description)

  return (
    <Grid item xs={12}>
      <Grid container className='w-100 bg-precedents-blue-10 pa6'>
        <Grid item xs={3}>
          <label className='b' htmlFor='description'>Description</label>
        </Grid>
        <Grid item xs={9}>
          <TextareaAutosize
            className='w-100'
            rowsMin={10}
            name='description'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Description
